<script setup>
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useSupportPlanCriteriaStore } from '@/stores/supportPlanCriteria';

const { searchSupportPlanCriteria } = useSupportPlanCriteriaStore();
const { supportPlanCriteria } = storeToRefs(useSupportPlanCriteriaStore());

import { inject } from 'vue';
import { trans } from 'laravel-vue-i18n';
const modals = inject('modals');

const props = defineProps({
    supportPlan: {
        type: Object,
        default: () => null
    }
});

const params = ref({
    term: '',
    page: 1,
    per_page: 10,
});

const fetchSupportPlanCriteria = () => {
    searchSupportPlanCriteria({
        ...params.value,
        hash: props.supportPlan.hash,
    });
};

const openSupportPlanCriteriaModal = (supportPlanCriteria = null) => {
    modals.show('SupportPlanCriteriaModal', {
        props: {
            mode: supportPlanCriteria ? 'Edit' : 'Create',
            criteria: supportPlanCriteria ? supportPlanCriteria : {},
            supportPlan: props.supportPlan,
        }
    }).then(() => {
        fetchSupportPlanCriteria();
    });
};

const tableUpdate = ({ page, sortBy, itemsPerPage }) => {
    Object.assign(params.value, { page, sort_by: sortBy, per_page: itemsPerPage });
    fetchSupportPlanCriteria();
};

const criteriaHeaders = computed(() => {
    return [
        { title: trans('label.title'), key: 'title', value: item => `${item.title}` },
        { title: trans('label.description'), key: 'description', value: item => `${item.description}` },
        { title: trans('label.type'), key: 'type', value: item => `${item.type.name}` },
        { title: trans('label.unit_name'), key: 'measurable_unit_name', value: item => `${item.type.name == 'Measurable Criteria' ? item.measurable_unit_name : '-'}` },
        { title: trans('label.target'), key: 'measurable_unit_target', value: item => `${item.type.name == 'Measurable Criteria' ? item.measurable_unit_target : '-'}` },
    ];
});
</script>

<template>
<div>
    <div class="flex justify-end pb-4">
        <StyledButton @click="openSupportPlanCriteriaModal(null)">
            <FontAwesomeIcon icon="plus" class="mr-1" />{{ $t('label.new_criteria') }}
        </StyledButton>
    </div>
    <DataTable
        v-if="supportPlanCriteria && supportPlanCriteria.data"
        :data="supportPlanCriteria"
        :headers="criteriaHeaders"
        :actions="[
            {
                title: $t('label.edit'),
                icon: 'mdi-pencil',
                action: (item) => openSupportPlanCriteriaModal(item),
            },
        ]" 
        @table-update="tableUpdate" />
    <div v-else>
        {{ $t('label.no_support_plan_criteria') }}
    </div>
</div>
</template>
